import {createRouter, createWebHashHistory, RouteRecordRaw} from 'vue-router';
import Layout from '../layout/layout.vue';
import CustomDevice from '../pages/customDevice/index.vue'

import pageRoutes from '~pages';


console.log('pageRoutes');
console.log(pageRoutes);


const excludePathList = ['/login', '/demo', '/admin', '/deviceconfig', '/devicedashboard', '/platformstatistics'];

// 设备管理写了两个页面， 实际功能都差不多， 很不好维护， 特殊处理一下
// const specialPages = [ '/device']

const excludePages: RouteRecordRaw[] = [];
const layoutPages = pageRoutes.filter(k => {
  // if(specialPages.includes(k.path)){
  //   return false;
  // }


  if (excludePathList.includes(k.path)) {
    excludePages.push(k);
    return false;
  }
  return true;
});

const routes = [
  {
    path: '/',
    redirect: '/situationMap',
    strict: true,
    component: Layout,
    children: [
      ...layoutPages,
      // {
      //   path: '/device',
      //   name: 'device',
      //   component: () => import('../pages/customDevice/index.vue')
      // }
    ],
  },
  ...excludePages
];


console.log("routes----");
console.log(routes);

export const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
});
